import React, { Component } from "react";
import { getMessage } from "CONFIG/i18n";

import {
  ERROR
} from "UTILS/Constants";

import { Row, Col } from "reactstrap";
import session_img from "../../Assets/Images/menu_icons/icon_guest.svg";
import HeaderContainer from "COMPONENTS/Header/HeaderContainer";
import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

import "./UserEvicted.less";

class UserEvicted extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderContainer />
        <div className="userEvicted joinSession">
          <section className="bgColor displayFlex flexDirectionColumn">
            <div className="languageSelection">
              <div className="mt-1">
                <ChangeLanguage
                  onSelectChange={this.props.onSelectChange}
                  language={this.props.language}
                />
              </div>
            </div>
            <div className="px-2">
              <div className="sessionImgArea col-12 col-xl-6 offset-xl-3 d-flex justify-content-center">
                <div className="col-4 p-0 d-flex flex-column">
                  <Row className="noMargin pb-4">
                    <div
                      className="text-center pt-5"
                    >
                      <img
                        src={session_img}
                        className="img-responsive session-img"
                        alt={getMessage("WAITING_ROOM")}
                      />
                    </div>
                  </Row>
                </div>
              </div>
              <div className="flexDirectionColumn noMarginForMobile userEvictedHeadingContainer justifyContentFlexCenter alignItemsCenter mx-5">
                <div className="alignTextCenter">
                  <span className="userEvictedHeading">
                    {getMessage("USER_EVICTED_MESSAGE")}
                  </span>
                  <br />
                  <span className="sessionName">
                    {this.props.userSessionName}
                  </span>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default UserEvicted;
